<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import { getFirestore, collection, addDoc, serverTimestamp, updateDoc, doc  } from "firebase/firestore/lite"
import {firebase} from "../../../../../firebase-int";
import CryptoJS from 'crypto-js';
import { getStorage, ref, uploadBytesResumable, getDownloadURL,uploadBytes } from "firebase/storage";

const firestore = getFirestore(firebase);
const storage = getStorage(firebase);
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from 'vuelidate/lib/validators'

export default {
  page: {
    title: 'Edit Training',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      dismissSecs: 2,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      alertMessage:'',
      successStatus:true,
      processingData:false,
      isUploading:false,
      totalSize:0,
      currentSize:0,

      pvtData: "",
      secret: "123#$%",
      encData: "",

      title: 'Edit Training',
      items: [
        {
          text: 'Gebi',
          href: '/',
        },
        {
          text: 'Training',
          href: '/Training',
        },
        {
          text: 'Edit Training: '+this.$route.params.training.id,
          active: true,
        },
      ],
      files:[],
      fileNames:this.$route.params.training.fileNames,
      filesToBeWritten:this.$route.params.training.files,
      form: {
        title: this.$route.params.training.title,
        description:this.$route.params.training.description,
      },
      submit: false,
      submitted: false,
      formsubmit: false,
      typesubmit: false,

      
      calendarConfig: {
          wrap: true, 
          dateFormat: 'd/m/Y',       
        },
    }
  },
  validations: {
    form: {
      title: { required,  minLength: minLength(2) },
      description: { required,  minLength: minLength(5) },
    },
  },
  methods: {
    /**
     * Basic Form submit
     */
    removeItem(item)
    {
      if(!this.isUploading)
      {
        var index=this.fileNames.indexOf(item);
        this.fileNames.splice(this.fileNames.indexOf(item), 1);
        this.filesToBeWritten.splice(this.fileNames.indexOf(item), 1);
      }
    },
    async previewFiles(event) {
      this.files=[]
      
      for (var i = 0; i < event.target.files.length; i++) {
        this.files.push(event.target.files[i])
        this.fileNames.push(event.target.files[i].name)
        console.log(this.files[i].name);
        //await this.uploadFile(this.files[i], this.files[i].name)
      }
      //reset input file
      event.target.value='';
   },
    async handleSubmit(e) {
      this.submitted = true
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;
      // await this.uploadFiles()
      this.updateTraining()
    },

    async uploadFiles()
    {
      //disable button
      this.processingData=true;
      const secondsSinceEpoch = Math.round(Date.now() / 1000)
      this.filesToBeWritten=[]
      this.isUploading=true;
      for (const file of this.files) {
        await this.uploadFile(file, 'Debo_'+this.$store.state.auth.currentUser.id+'_'+secondsSinceEpoch+'_'+file.name)
      }
      this.isUploading=false;
      console.log('>>>>>>>>>>>>. this is end of for loop');
      console.log('>>>>>>>>>>>> links size: '+this.filesToBeWritten.length);
      for(const f of this.filesToBeWritten)
        console.log('>>>>>>>>>>>> File: '+f);
      this.updateTraining()
    },

    
    async updateTraining() {
      this.processingData=true;
      try {
        
            const docRef=doc(firestore, 'training', this.$route.params.training.id)
            await updateDoc(docRef, {
              title: this.form.title,
              description:this.form.description,
              //created: serverTimestamp(),
              updated: serverTimestamp(),
              //createdBy: this.$store.state.auth.currentUser.id,
              updatedBy: this.$store.state.auth.currentUser.id,
              files: this.filesToBeWritten,
              fileNames: this.fileNames,
            });
            //this.makeToast(false, "Document written with ID: ", docRef.id);
            this.successStatus=true;
            this.dismissSecs=2;
            this.alertMessage="Training updated with ID: "+ docRef.id;
            this.showAlert();
            console.log("Document written with ID: ", docRef.id);
            await this.addToLog('training updated', this.$store.state.auth.currentUser.id , docRef.id);
            //this.clearFields();
            setTimeout(() => {
              this.$router.push({ name: 'Training' })
            }, 2000)
          } catch (e) {
            console.error("Error updating document: ", e);
            this.successStatus=false;
            this.dismissSecs=4;
            this.alertMessage="Not able to update training data. Please try again.";
            this.showAlert();
            this.processingData=false;
          }
          //this.processingData=false;

      },
      async uploadFile(file, fileName)
      {
          //const storage = getStorage();
          const storageRef = ref(storage, 'trainings/'+fileName);

          await uploadBytes(storageRef, file).then(async (snapshot) => {
              //this.currentSize=(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              //this.totalSize=100;
            console.log('File uploaded!');
            await getDownloadURL(snapshot.ref).then((downloadURL) => {
                this.filesToBeWritten.push(downloadURL);
                console.log('File available at', downloadURL);
              });
          });
      },
      clearFields()
      {
        this.form.title= 'Training title';
        this.form.description= 'Description goes here';
        this.files=[]
        this.fileNames=[]
        this.filesToBeWritten=[]
        console.log('Data cleared!')
      },

      // alert related methods
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert() {
        this.dismissCountDown = this.dismissSecs
      },

      // encryption related methods
      encryptData(passwordData) {
        // return CryptoJS.AES.encrypt(JSON.stringify({ passwordData }), this.secret).toString();
        return CryptoJS.AES.encrypt(passwordData, this.secret).toString();
      },

      gotoTrainings()
      {
        this.$router.push({ name: 'Training', params: { userId: '123' } });
      },
      
  },
  mounted()
  {
    
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
      <b-alert v-if="successStatus" 
      :show="dismissCountDown"
      dismissible
      fade
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      <p>{{ alertMessage }}</p>
    </b-alert>
    <b-alert v-else 
      :show="dismissCountDown"
      dismissible
      fade
      variant="danger"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      <p>{{ alertMessage }}</p>
    </b-alert>

    
        <b-alert v-if="isUploading" 
          show
          fade
          variant="success"
          >
          <p>Uploading files please wait ...</p>
          <!--b-progress
            variant="warning"
            :max="totalSize"
            :value="currentSize"
            height="4px"
          ></b-progress-->
        </b-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">Training Information</h4>
            <p class="sub-header"
              >Enter training information here.</p
            >
            <form @submit.prevent="handleSubmit">
              <div class="form-group">
                <label for="title">
                  Title
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="title"
                  v-model="form.title"
                  name="title"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.title.$error }"
                  type="text"
                  placeholder="Enter title"
                />
                <div
                  v-if="submitted && $v.form.title.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.title.required"
                    >This value is required.</span
                  >
                  <span v-if="!$v.form.title.minLength"
                    >Title must be at least 2 characters.</span
                  >
                </div>
              </div>
              <div class="form-group">
                <label>
                  Description
                  <span class="text-danger">*</span>
                </label>
                <textarea
                  v-model="form.description"
                  type="text"
                  rows="5"
                  name="description"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.description.$error,
                  }"
                  placeholder="Enter description"
                />
                <div
                  v-if="submitted && $v.form.description.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.description.required"
                    >This value is required.</span
                  >
                  <span v-if="!$v.form.description.minLength"
                    >Description must be at least 5 characters.</span
                  >
                </div>
              </div>

              <div class="form-group">
                <label>
                  Attached Files (Click on file names to remove them)
                  <span class="text-danger">*</span>
                </label>
                <div>
                <ul id="example-1">
                  <li v-for="item in fileNames" :key="item" style="margin:10px 0">
                    <b-button @click="removeItem(item)" variant="outline-primary">{{ item }}</b-button>
                  </li>
                </ul>
                </div>
                <!--div>
                <input v-if="isUploading" type="file" @change="previewFiles" disabled multiple>
                <input v-else type="file" @change="previewFiles" multiple>
                </div-->
                
              </div>

              
            </form>
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->

    </div>
    <!-- end row -->

    
    
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
                  
            <!--form @submit.prevent="handleSubmit">
                  <button v-if='!processingData' type="submit" class="btn btn-primary"
                    >Save</button>
                  <button v-else disabled  class="btn btn-primary"
                  >Save</button>
                  <a href="/member">
                  <button class="btn btn-secondary m-l-5 ml-1"
                    >Cancel</button></a>
            </form-->
            <form @submit.prevent="handleSubmit">
            <template>
              <b-button  v-if='!processingData' type="submit" variant="primary"><i class="uil uil-down-arrow mr-1"></i>Save Changes</b-button>
              <b-button  v-else disabled type="submit" variant="primary"><i class="uil uil-down-arrow mr-1"></i>Save Changes</b-button>
							<b-button variant="light" @click="gotoTrainings" style="margin-left:10px;">Close</b-button>
									
								</template>
            </form>
                  
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    
  </Layout>
</template>
